export default Object.freeze({
  "246": "Banco ABC Brasil S.A.",
  "075": "Banco ABN AMRO S.A.",
  "299": "Banco Afinz S.A.Banco Múltiplo",
  "121": "Banco Agibank S.A.",
  "025": "Banco Alfa S.A.",
  "641": "Banco Alvorada S.A.",
  "065": "Banco Andbank(Brasil) S.A.",
  "213": "Banco Arbi S.A.",
  "096": "Banco B3 S.A.",
  "024": "Banco BANDEPE S.A.",
  "330": "Banco Bari de Investimentos e Financiamentos S/ A",
  "318": "Banco BMG S.A.",
  "752": "Banco BNP Paribas Brasil S.A.",
  "107": "Banco BOCOM BBM S.A.",
  "063": "Banco Bradescard S.A.",
  "036": "Banco Bradesco BBI S.A.",
  "122": "Banco Bradesco BERJ S.A.",
  "204": "Banco Bradesco Cartões S.A.",
  "394": "Banco Bradesco Financiamentos S.A.",
  "237": "Banco Bradesco S.A.",
  "218": "Banco BS2 S.A.",
  "208": "Banco BTG Pactual S.A.",
  "626": "Banco C6 Consignado S.A.",
  "473": "Banco Caixa Geral - Brasil S.A.",
  "040": "Banco Cargill S.A.",
  "266": "Banco Cédula S.A.",
  "739": "Banco Cetelem S.A.",
  "233": "Banco Cifra S.A.",
  "745": "Banco Citibank S.A.",
  "241": "Banco Clássico S.A.",
  "756": "Banco Cooperativo Sicoob S.A.",
  "748": "Banco Cooperativo Sicredi S.A.",
  "222": "Banco Credit Agricole Brasil S.A.",
  "505": "Banco Credit Suisse(Brasil) S.A.",
  "069": "Banco Crefisa S.A.",
  "003": "Banco da Amazônia S.A.",
  "083": "Banco da China Brasil S.A.",
  "707": "Banco Daycoval S.A.",
  "51": "Banco de Desenvolvimento do Espírito Santo S.A.",
  "300": "Banco de La Nacion Argentina",
  "495": "Banco de La Provincia de Buenos Aires",
  "494": "Banco de La Republica Oriental del Uruguay",
  "654": "Banco Digimais S.A.",
  "001": "Banco do Brasil S.A.",
  "047": "Banco do Estado de Sergipe S.A.",
  "037": "Banco do Estado do Pará S.A.",
  "041": "Banco do Estado do Rio Grande do Sul S.A.",
  "004": "Banco do Nordeste do Brasil S.A.",
  "265": "Banco Fator S.A.",
  "224": "Banco Fibra S.A.",
  "094": "Banco Finaxis S.A.",
  "125": "Banco Genial S.A.",
  "612": "Banco Guanabara S.A.",
  "012": "Banco Inbursa S.A.",
  "604": "Banco Industrial do Brasil S.A.",
  "077": "Banco Inter S.A.",
  "249": "Banco Investcred Unibanco S.A.",
  "184": "Banco Itaú BBA S.A.",
  "029": "Banco Itaú Consignado S.A.",
  "479": "Banco ItauBank S.A",
  "376": "Banco J.P.Morgan S.A.",
  "074": "Banco J.Safra S.A.",
  "217": "Banco John Deere S.A.",
  "076": "Banco KDB S.A.",
  "757": "Banco KEB HANA do Brasil S.A.",
  "630": "Banco Letsbank S.A.",
  "600": "Banco Luso Brasileiro S.A.",
  "243": "Banco Master S.A.",
  "389": "Banco Mercantil do Brasil S.A.",
  "370": "Banco Mizuho do Brasil S.A.",
  "746": "Banco Modal S.A.",
  "066": "Banco Morgan Stanley S.A.",
  "456": "Banco MUFG Brasil S.A.",
  "007": "Banco Nacional de Desenvolvimento Econômico e Social - BNDES",
  "079": "Banco Original do Agronegócio S.A.",
  "212": "Banco Original S.A.",
  "712": "Banco Ourinvest S.A.",
  "623": "Banco PAN S.A.",
  "611": "Banco Paulista S.A.",
  "643": "Banco Pine S.A.",
  "658": "Banco Porto Real de Investimentos S.A.",
  "747": "Banco Rabobank International Brasil S.A.",
  "633": "Banco Rendimento S.A.",
  "741": "Banco Ribeirão Preto S.A.",
  "720": "BANCO RNX S.A",
  "120": "Banco Rodobens S.A.",
  "422": "Banco Safra S.A.",
  "033": "Banco Santander(Brasil) S.A.",
  "743": "Banco Semear S.A.",
  "276": "Banco Senff S.A.",
  "754": "Banco Sistema S.A.",
  "366": "Banco Société Générale Brasil S.A.",
  "637": "Banco Sofisa S.A.",
  "464": "Banco Sumitomo Mitsui Brasileiro S.A.",
  "082": "Banco Topázio S.A.",
  "634": "Banco Triângulo S.A.",
  "018": "Banco Tricury S.A.",
  "653": "Banco Voiter S.A.",
  "655": "Banco Votorantim S.A.",
  "610": "Banco VR S.A.",
  "119": "Banco Western Union do Brasil S.A.",
  "124": "Banco Woori Bank do Brasil S.A.",
  "348": "Banco XP S.A.",
  "081": "BancoSeguro S.A.",
  "021": "BANESTES S.A.Banco do Estado do Espírito Santo",
  "755": "Bank of America Merrill Lynch Banco Múltiplo S.A.",
  "250": "BCV - Banco de Crédito e Varejo S.A.",
  "144": "BEXS Banco de Câmbio S.A.",
  "017": "BNY Mellon Banco S.A.",
  "126": "BR Partners Banco de Investimento S.A.",
  "128": "Braza Bank S.A.Banco de Câmbio",
  "070": "BRB - Banco de Brasília S.A.",
  "092": "Brickell S.A.Crédito Financiamento e Investimento",
  "104": "Caixa Econômica Federal",
  "114-7": "Central das Cooperativas de Economia e Crédito Mútuo do Estado do Espírito Santo Ltda.",
  "320": "China Construction Bank(Brasil) Banco Múltiplo S.A.",
  "477": "Citibank N.A.",
  "163": "Commerzbank Brasil S.A. - Banco Múltiplo",
  "085": "Cooperativa Central de Crédito - AILOS",
  "097": "Cooperativa Central de Crédito Noroeste Brasileiro Ltda.",
  "090-2": "Cooperativa Central de Economia e Crédito Mutuo - SICOOB UNIMAIS",
  "087-6": "Cooperativa Central de Economia e Crédito Mútuo das Unicreds de Santa Catarina e Paraná",
  "089-2": "Cooperativa de Crédito Rural da Região da Mogiana",
  "098-1": "CREDIALIANÇA COOPERATIVA DE CRÉDITO RURAL",
  "487": "Deutsche Bank S.A. - Banco Alemão",
  "478": "Gazincred S.A. Sociedade de Credito Financiamento e Investimento",
  "064": "Goldman Sachs do Brasil Banco Múltiplo S.A.",
  "078": "Haitong Banco de Investimento do Brasil S.A.",
  "062": "Hipercard Banco Múltiplo S.A.",
  "269": "HSBC Brasil S.A.",
  "132": "ICBC do Brasil Banco Múltiplo S.A.",
  "492": "ING Bank N.V.",
  "139": "Intesa Sanpaolo Brasil S.A. - Banco Múltiplo",
  "652": "Itaú Unibanco Holding S.A.",
  "341": "Itaú Unibanco S.A.",
  "488": "JPMorgan Chase Bank National Association",
  "399": "Kirton Bank S.A. - Banco Múltiplo",
  "753": "Novo Banco Continental S.A. - Banco Múltiplo",
  "613": "Omni Banco S.A.",
  "254": "Paraná Banco S.A.",
  "751": "Scotiabank Brasil S.A.Banco Múltiplo",
  "412": "Social Bank Banco Múltiplo",
  "118": "Standard Chartered Bank(Brasil) S / A–Bco Invest.",
  "014": "State Street Brasil S.A. - Banco Comercial",
  "095": "Travelex Banco de Câmbio S.A.",
  "129": "UBS Brasil Banco de Investimento S.A.",
  "091-4": "Unicred Central do Rio Grande do Sul",
  "084": "Uniprime Norte do Paraná - Coop de Economia e Crédito Mútuo dos Médicos Profissionais das Ciências",
  "359": "Zema Credito Financiamento e Investimento S.A.",
});
